var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.217,
    height: 11.815,
    viewBox: "0 0 15.217 11.815",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M5.827,11.994a.777.777,0,0,1-1.1,0L.341,7.607a1.165,1.165,0,0,1,0-1.648l.549-.549a1.165,1.165,0,0,1,1.648,0L5.277,8.148l7.4-7.4a1.165,1.165,0,0,1,1.648,0l.549.549a1.165,1.165,0,0,1,0,1.648Zm0,0",
    transform: "translate(0 -0.406)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.cb3472bfc99a5d4fa86e1df3ffb4b39b.svg";
export { ForwardRef as ReactComponent };